export const PointDalli = () => (
	<svg width="50" height="58" viewBox="0 0 50 58" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_dd_25188_21666)">
			<path
				d="M40 19.75C40 32.6875 25 40 25 40C25 40 10 32.4062 10 19.75C10 11.0515 16.7157 4 25 4C33.2843 4 40 11.0515 40 19.75Z"
				fill="#002A47"
			/>
		</g>
		<path
			d="M30.4129 23.5648C30.0002 23.5302 29.6058 23.3808 29.2757 23.1341C29.2403 23.1083 29.199 23.0913 29.1555 23.0847C29.1119 23.078 29.0674 23.0818 29.0257 23.0958C28.984 23.1097 28.9463 23.1334 28.9158 23.1649C28.8854 23.1963 28.8631 23.2345 28.8509 23.2762C28.572 24.1722 28.0974 24.9971 27.4604 25.6929C27.4339 25.7217 27.4141 25.7558 27.4022 25.7929C27.3904 25.8299 27.3868 25.8691 27.3918 25.9076C27.3968 25.9462 27.4102 25.9832 27.4311 26.0162C27.4519 26.0492 27.4798 26.0773 27.5127 26.0986C28.3489 26.6353 29.3143 26.944 30.3109 26.9931C30.3481 26.995 30.3853 26.9894 30.4203 26.9766C30.4552 26.9639 30.4872 26.9442 30.5142 26.9189C30.5413 26.8936 30.5628 26.8632 30.5775 26.8294C30.5923 26.7957 30.5999 26.7593 30.6 26.7226V23.7659C30.6 23.7154 30.5809 23.6667 30.5462 23.6294C30.5116 23.5922 30.464 23.5691 30.4129 23.5648ZM28.3672 11.2517C28.3672 11.2186 28.3606 11.1859 28.3478 11.1553C28.335 11.1248 28.3161 11.097 28.2924 11.0736C28.2686 11.0502 28.2405 11.0317 28.2094 11.0191C28.1785 11.0064 28.1452 11 28.1117 11H25.1453C25.0776 11 25.0127 11.0265 24.9648 11.0737C24.9169 11.1209 24.89 11.1849 24.89 11.2517V21.4983C24.8934 21.8728 24.7908 22.2409 24.5937 22.5611C24.3966 22.8813 24.1129 23.141 23.7744 23.311C22.1199 24.1169 20.4766 22.9425 20.4766 21.397C20.4766 21.0249 20.5733 20.6591 20.7576 20.3344C20.9419 20.0098 21.2075 19.7371 21.5292 19.5426C21.8509 19.348 22.2178 19.2381 22.5948 19.2232C22.9719 19.2083 23.3466 19.2891 23.683 19.4577C23.7247 19.4796 23.7715 19.4905 23.8188 19.4894C23.866 19.4883 23.9122 19.4751 23.9529 19.4513C23.9935 19.4274 24.0271 19.3935 24.0506 19.3531C24.0741 19.3126 24.0865 19.2668 24.0868 19.2202V16.2215C24.0867 16.1478 24.0608 16.0764 24.0135 16.0194C23.9662 15.9623 23.9003 15.9231 23.8271 15.9083C23.001 15.7412 22.1475 15.7575 21.3285 15.9558C20.5095 16.1542 19.7456 16.5297 19.092 17.0551C18.4385 17.5805 17.9117 18.2427 17.5498 18.9937C17.188 19.7447 17.0002 20.5656 17 21.397C17 25.1253 20.7129 28.0147 24.6849 26.6605C26.9077 25.9027 28.3669 23.7985 28.3669 21.4801L28.3672 11.2517Z"
			fill="white"
		/>
		<defs>
			<filter
				id="filter0_dd_25188_21666"
				x="0"
				y="0"
				width="50"
				height="58"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21666" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21666" result="effect2_dropShadow_25188_21666" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_25188_21666" result="shape" />
			</filter>
		</defs>
	</svg>
)
